<template>
     <div class="input-group">
          <span class="search-select">Usuario</span>
          <model-select :options="adminOptions"
            v-model="adminId"
            placeholder="Usuario">
          </model-select>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import listAdmins from  '../../graphql/queries/listAdmins.gql'
import axios from 'axios'
import { print } from 'graphql'

export default {
    components: {
        ModelSelect,
    },
    data() {
        return {
            adminId:'',
            adminUsers: []
        }
    },
    computed: {
        adminOptions() {
            if(this.adminUsers[0]) {
                return this.adminUsers.map(user => { return {text: `${user.firstname} ${user.lastname}`, value: user.id}})
            }
            return []
            
        }
    },
    mounted() {
        this.getAdminUsers();
    },
    methods: {
        getAdminUsers() {
            //this.isLoading = true;
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                params: {
                    query: print(listAdmins),
                    variables: {
                    currentUserToken: localStorage.getItem("USER_TOKEN"),
                    },
                },
                })
                .then((rta) => {
                if (!rta.data.errors) {
                    this.adminUsers = rta.data.data.listAdmins;
                    //this.isLoading = false;
                } 
                });
        },
    },
    watch: {
        adminId() {
            this.$emit('adminSelected');
        } 
    }
}
</script>